import { render } from "./page-drawer.vue?vue&type=template&id=665f80aa&scoped=true"
import script from "./page-drawer.vue?vue&type=script&lang=js"
export * from "./page-drawer.vue?vue&type=script&lang=js"

import "./page-drawer.vue?vue&type=style&index=0&id=665f80aa&scoped=true&lang=less"
import "./page-drawer.vue?vue&type=style&index=1&id=665f80aa&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665f80aa"]])

export default __exports__